<div class="layout-row layout-align-center-center full-height">
  <bz-card [padded]="false" class="actions-card" appBringozIdGenerator="threepl-services-action-footer">
    <div class="layout-row full-height">

      <div class="layout-column layout-align-center-start" id="actions-card-counter">
        <div class="br-head-2 font-weight-500 margin-bottom-5">{{ selectedServices().length }} {{ 'Services Selected' | translate }}</div>
        <bz-divider></bz-divider>
        <app-threepl-services-totals-indication id="deliveries-totals" [services]="selectedServices()"></app-threepl-services-totals-indication>
      </div>

      <div class="flex layout-row layout-align-start-center margin-left-5">
        <bz-button variant="tertiary" size="fit" class="action-button" appBringozIdGenerator="threepl-services-footer-add-note-button"
                   (clicked)="addNoteToServices.emit($event)">
          <span class="layout-column layout-align-center-center action-content">
            <bz-icon size="xxl" [icon]="icons.note"></bz-icon>
            <span class="br-body-1">{{ 'Add Note' | translate }}</span>
          </span>
        </bz-button>

        <bz-button variant="tertiary" size="fit" class="action-button" appBringozIdGenerator="threepl-services-footer-cancel-button"
                   (clicked)="cancelServices.emit()">
          <span class="layout-column layout-align-center-center action-content">
            <bz-icon size="xxl" [icon]="icons.cancel"></bz-icon>
            <span class="br-body-1">{{ 'Cancel' | translate }}</span>
          </span>
        </bz-button>

        <bz-button variant="tertiary" tone="secondary" size="fit" class="unselect-button" appBringozIdGenerator="threepl-services-footer-unselect-button"
                   [ariaLabel]="'Unselect all' | translate"
                   (clicked)="unselectAll.emit()">
          <bz-icon [icon]="icons.unselect"></bz-icon>
        </bz-button>
      </div>

    </div>
  </bz-card>
</div>
